import React from 'react';
import { sortByNumericThenAlpha } from '@awp/helpers/sorter';
import { actionMenu } from './NotificationCommon';

/**
 * Returns an array of table column definitions for the notifications table.
 *
 * @returns {Array} Table columns configuration.
 */
export const getTableColumns = (context) => {
  return [
    {
      Header: '', // Empty header for icon column
      accessor: 'IsPrivate', // Accessor for private/public status
      sortType: sortByNumericThenAlpha, // Custom sort function
      Cell: (props) => {
        return props.row.original.IsPrivate === 'N' ? (
          <div>
            <i className="fas fa-solid fa-globe mx-1 my-1" title="Public" />
          </div>
        ) : (
          <div>
            <i className="fas fa-solid fa-user mx-1 my-1" title="Private" />
          </div>
        );
      },
    },
    {
      Header: 'Name', // Header for the Name column
      accessor: 'Name', // Accessor for notification name
      sortType: sortByNumericThenAlpha, // Custom sort function
    },
    {
      Header: 'Date Range', // Header for the Date Range column
      accessor: 'DateRangeForSort', // Accessor for sortable date range
      sortType: sortByNumericThenAlpha, // Custom sort function
      Cell: (row) => {
        return row.value ? row.value.split('-')[1] : ''; // Extracting the end date from the range
      },
    },
    {
      Header: 'Frequency', // Header for the Frequency column
      accessor: 'NotificationIntervalHours', // Accessor for notification interval in hours
      sortType: sortByNumericThenAlpha, // Custom sort function
      Cell: (row) => {
        if (row.value === 0) {
          return 'No Limit'; // Display for no limit frequency
        } else if (row.value === 1) {
          return `${row.value} hour`; // Singular display for 1 hour
        } else {
          return `${row.value} hours`; // Plural display for multiple hours
        }
      },
    },
    {
      Header: 'Alert Logic', // Header for the Alert Logic column
      accessor: 'TriggerCondition', // Accessor for the trigger condition
      sortType: sortByNumericThenAlpha, // Custom sort function
      Cell: (props) => {
        return props.row.original.IsForMissingObservations === 'Y'
          ? 'Partial/No Data' // Display logic for missing observations
          : props.row.original.TriggerCondition; // Display trigger condition otherwise
      },
    },
    {
      Header: 'Active', // Header for the Active column
      accessor: 'IsActive', // Accessor for active status
      sortType: sortByNumericThenAlpha, // Custom sort function
      Cell: (row) => {
        if (row.value === 'Y') {
          return 'Yes'; // Display for active status
        } else {
          return 'No'; // Display for inactive status
        }
      },
    },
    {
      Header: 'Stations/Area', // Header for the Weather Stations column
      accessor: (row) => row.WeatherStations || row.GeographicAreas,
      sortType: sortByNumericThenAlpha, // Custom sort function
      Cell: ({ value }) => {
        if (value) {
          const _array = value.split(',').map((item) => item.trim()); // Splitting and trimming the value
          return _array.join(', '); // Joining for display
        } else {
          return ''; // Empty display if no data
        }
      },
    },
    {
      Header: 'Actions', // Header for the Actions column
      accessor: 'NotificationTriggerId', // Accessor for notification ID
      disableSortBy: true, // Disables sorting for this column
      Cell: (row) => {
        return actionMenu(row, context); // Renders the action menu
      },
    },
  ];
};
